var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_561_5793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.75 8C14.75 7.58579 14.4142 7.25 14 7.25C13.5858 7.25 13.25 7.58579 13.25 8H14.75ZM13.1973 5V5.75C13.6115 5.75 13.9473 5.41421 13.9473 5H13.1973ZM13.9473 2C13.9473 1.58579 13.6115 1.25 13.1973 1.25C12.7831 1.25 12.4473 1.58579 12.4473 2H13.9473ZM10.25 4.25C9.83579 4.25 9.5 4.58579 9.5 5C9.5 5.41421 9.83579 5.75 10.25 5.75V4.25ZM13.25 8C13.25 10.8995 10.8995 13.25 8 13.25V14.75C11.7279 14.75 14.75 11.7279 14.75 8H13.25ZM8 13.25C5.1005 13.25 2.75 10.8995 2.75 8H1.25C1.25 11.7279 4.27208 14.75 8 14.75V13.25ZM2.75 8C2.75 5.1005 5.1005 2.75 8 2.75V1.25C4.27208 1.25 1.25 4.27208 1.25 8H2.75ZM8 2.75C9.9423 2.75 11.6392 3.80436 12.5481 5.37554L13.8465 4.62446C12.6805 2.60883 10.4994 1.25 8 1.25V2.75ZM13.9473 5V2H12.4473V5H13.9473ZM13.1973 4.25H10.25V5.75H13.1973V4.25Z",
    fill: "#26B0EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_561_5793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.4bebec767138200677d412a7f96b07ce.svg";
export { ForwardRef as ReactComponent };